import { fetchGet, objectify } from '../../utils';
export const fetch = async (query: { Supplier: number }): Promise<{ values: any; schema: any }> => {
  const { Supplier } = query;
  const respType = 'Inline';

  return fetchGet(`/SupplierEnquiry/Settings/General/Supplier/${Supplier}`, null, respType)
    .then(
      (result: {
        Settings: any;
      }) => {
        if (result) {
          if (result.Settings) {

            return {
              values: objectify(result.Settings),
              schema: result.Settings,
            };
          }
        }

        return {
          values: null,
          schema: null,
        };
      });
};
